<template>
  <div class="board-list-wrapper">
    <div class="board-content">
      <BoardSearch
        v-if="showSearch"
        :placeholder="searchPlaceholder"
        v-model="searchKeyword"
        @search="handleSearch"
      />

      <div class="board">
        <ul>
          <li
            v-for="board in boards"
            :key="board.id"
            @click="handleBoardClick(board.id)"
          >
            <span class="board__badge" :class="board.type == 1 ? 'notice-badge' : 'news-badge'">
              {{board.type == 1 ? "공지" : "뉴스"}}
            </span>
            <div>
              <div class="board__title">{{ board.title }}</div>
              <div class="board__date">{{ formatDate(board.mod_dttm) }}</div>
            </div>
          </li>
        </ul>
      </div>

      <!-- 검색 결과 없음 -->
      <div v-if="!loading && boards.length === 0" class="empty-container">
        <p class="empty-text">검색 결과가 없습니다.</p>
      </div>

      <button
        class="btn"
        v-if="showMoreButton && !loading"
        @click="handleLoadMore"
      >
        더보기
      </button>
    </div>
  </div>
</template>

<script>
import BoardSearch from "./BoardSearch.vue";

export default {
  name: 'BoardList',
  components: {
    BoardSearch
  },
  props: {
    boards: {
      type: Array,
      required: true,
      default: () => []
    },
    detailPath: {
      type: String,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: '검색어를 입력하세요'
    },
    showMoreButton: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyword: ''
    };
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        return date.split('T')[0];
      }
    },
    handleBoardClick(id) {
      this.$router.push(`${this.detailPath}/${id}`);
    },
    handleSearch(keyword) {
      this.$emit('search', keyword);
    },
    handleLoadMore() {
      this.$emit('load-more');
    }
  }
};
</script>

<style scoped lang="scss">
.board-list-wrapper {
  width: 100%;
  min-height: 55px;
}

.board-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 38px 100px;

  .btn {
    margin-top: 66px;
    font-size: 23.55px;
    line-height: 69.25px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #222;
    width: 100%;
    cursor: pointer;
    background: white;

    &:hover {
      background: #f5f5f5;
    }
  }

  .board ul {
    margin-top: 32px;

    &:first-child {
      border-top: 1px solid #222;
    }
  }

  .board ul li {
    display: grid;
    gap: 15px;
    padding: 20px 15px 20px 0;
    align-items: center;
    grid-template-columns: max-content 1fr;
    border-bottom: 1px solid #DEDEDE;
    cursor: pointer;

    .board__badge {
      font-size: 22.16px;
      line-height: 27.7px;
      letter-spacing: -0.75px;
      vertical-align: middle;
      padding: 11px 12px;

      &.news-badge {
        background: #F0F8FF;
      }

      &.notice-badge {
        background: #DEDEDE;
      }
    }

    .board__title {
      font-size: 22.16px;
      line-height: 41.55px;
      vertical-align: middle;
    }

    .board__date {
      margin-top: 18px;
      font-size: 22.16px;
      line-height: 22.16px;
      letter-spacing: -0.75px;
      vertical-align: middle;
      color: #aaa;
    }
  }

  .empty-container {
    text-align: center;
    padding: 80px 20px;
    margin-top: 32px;
  }

  .empty-text {
    font-size: 18px;
    color: #666;
    line-height: 1.6;
  }

  // =========================================================================
  // 모바일 반응형 (768px 이하)
  // =========================================================================
  @media (max-width: 768px) {
    padding: 40px 20px 60px;

    .btn {
      margin-top: 40px;
      font-size: 18px;
      line-height: 52px;
      min-height: 48px;
    }

    .board ul {
      margin-top: 24px;
    }

    .board ul li {
      padding: 16px 0;
      gap: 12px;
      min-height: 48px;

      .board__badge {
        font-size: 14px;
        line-height: 20px;
        padding: 6px 10px;
      }

      .board__title {
        font-size: 16px;
        line-height: 24px;
        word-break: keep-all;
      }

      .board__date {
        margin-top: 8px;
        font-size: 14px;
        line-height: 18px;
      }
    }

    .empty-container {
      padding: 60px 20px;
    }

    .empty-text {
      font-size: 16px;
    }
  }
}
</style>
